const BUSINESS_ERROR_TYPES = {
  LICENSE_NOT_GRANTED: 'LicenseNotGranted',
  GEO_LOCATION_BLOCKED: 'GeoLocationBlocked',
  CONCURRENCY_LIMIT_VIOLATION: 'ConcurrencyLimitViolation',
  DUPLICATE_LIVE_STREAM_VIOLATION: 'DuplicateLiveStreamViolation',
  DEVICE_NOT_GRANTED: 'DeviceNotGranted',
} as const;

export const BusinessErrors = Object.values(BUSINESS_ERROR_TYPES);

export const businessErrorMessage = (businessError: BusinessErrorTypes) => {
  switch (businessError) {
    case BUSINESS_ERROR_TYPES.GEO_LOCATION_BLOCKED:
      return 'GeoBlocked';
    default:
      return businessError;
  }
};

export type BusinessErrorTypes = (typeof BUSINESS_ERROR_TYPES)[keyof typeof BUSINESS_ERROR_TYPES];
